import CustomSelect from "../Layout/CustomSelect";
import SwitchToggle from "../Layout/MiniDisplays/SwitchToggle";
import { fontSizeOptions } from "../../Data/FontSizes";
import { themeOptions } from "../../Data/ThemeData";
import '../../Styles/Settings/PreferencesSection.css';
import { useWindow } from "../../contexts/WindowContext";
import { useSettings } from "../../contexts/SettingsContext";
import { useChatContext } from "../../contexts/AppDataContext";

export const PreferencesSection = () => {
  const { enhancedPromptFixing, setEnhancedPromptFixing } = useSettings();
  const {
    webCapable,
    setWebCapable,
    resourceCapable,
    setResourceCapable,
  } = useChatContext();
  const {
    fontSize,
    setFontSize,
    theme,
    setTheme
  } = useWindow();


  return (
    <>
      <div className="settings-item">
        <h3>Display Settings</h3>
        <div className="settings-row">
          <div>
            <span>Font Size</span>
            <p className="setting-description">Adjust the text size across the application</p>
          </div>
          <CustomSelect
            options={fontSizeOptions}
            value={fontSize}
            onChange={(value) => setFontSize(value)}
          />
        </div>
      </div>
      
      <div className="settings-item">
        <h3>Prompt Fixing</h3>
        <div className="settings-row horizontal">
          <div>
            <span>Enhanced Prompt Fixing</span>
            <p className="setting-description">
              Improves prompts beyond basic grammar correction, rephrasing and adjusting
              structure to better convey intended meaning to the AI.
            </p>
          </div>
          <SwitchToggle
            isChecked={enhancedPromptFixing}
            setIsChecked={() => setEnhancedPromptFixing(!enhancedPromptFixing)}
          />
        </div>
      </div>

      <div className="settings-item">
        <h3>Capabilities</h3>
        <div className="settings-row horizontal">
          <div>
            <span>Web Search</span>
            <p className="setting-description">
              Buddy will search the web when it feels like it requests information from the web.
            </p>
          </div>
          <SwitchToggle
            isChecked={webCapable}
            setIsChecked={(value) => setWebCapable(value)}
          />
        </div>
        <div className="settings-row horizontal">
          <div>
            <span>Resources</span>
            <p className="setting-description">
              Buddy will generate documents and visualizations in a dedicated space.
            </p>
          </div>
    
          <SwitchToggle
            isChecked={resourceCapable}
            setIsChecked={(value) => setResourceCapable(value)}
          />
        </div>
      </div>
      
      <div className="settings-item">
        <h3>Theme Settings</h3>
        <div className="settings-row">
          <div>
            <span>Color Theme</span>
            <p className="setting-description">Choose your preferred color theme</p>
          </div>
          <div className="theme-options">
            {themeOptions.map((option) => (
              <div
                key={option.value}
                className={`theme-option ${theme === option.value ? 'active' : ''}`}
                onClick={() => setTheme(option.value as 'light' | 'dark' | 'system')}
              >
                <div className={`theme-option-preview theme-preview-${option.value}`}>
                  <div className="theme-preview-bars">
                    <div className="theme-preview-bar bar-1" />
                    <div className="theme-preview-bar bar-2" />
                    <div className="theme-preview-bar bar-3" />
                  </div>
                </div>
                <div className="theme-option-label">{option.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}; 